exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.whishlist-count[data-v-26786298] {\n  top: 7px;\n  left: 50%;\n  min-width: 16px;\n  min-height: 16px;\n  border-radius: 10px;\n}\n.fs11[data-v-26786298] {\nfont-size: 11px;\n}\n", ""]);

// exports
